export default __webpack_public_path__ + "static/media/LeftFourButton.ac5fa533.webp";